import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import useSeo from "@/hooks/useSeo";
import useAdminApi from "@/hooks/useAdminApi";
import BookingsTab from "@/pages/admin/BookingsTab";
import RoomsTab from "@/pages/admin/RoomsTab";
import SettingsTab from "@/pages/admin/SettingsTab";
import UsersTab from "@/pages/admin/UsersTab";
import OfflineTab from "@/pages/admin/OfflineTab";

const Dashboard = () => {
  const call = useAdminApi();
  const [me, setMe] = useState(null);
  useEffect(() => {
    call("get", "/me").then(setMe).catch(() => setMe({ role: "error" }));
  }, [call]);

  if (!me) return <p className="text-sm text-[#6b6b6b]">Loading…</p>;
  if (me.role !== "admin") {
    return (
      <div className="bg-white border border-[#E2DCD0] p-8 max-w-lg" data-testid="admin-access-denied">
        <h2 className="text-3xl text-[#1E3B2E]">Access restricted</h2>
        <p className="mt-3 text-sm text-[#6b6b6b]">This account does not have admin access. Ask an existing admin to grant you access.</p>
      </div>
    );
  }
  return (
    <Tabs defaultValue="bookings" data-testid="admin-dashboard">
      <TabsList className="bg-transparent border-b border-[#E2DCD0] rounded-none w-full justify-start h-auto p-0 gap-6 overflow-x-auto">
        {["bookings", "rooms", "settings", "offline", "users"].map((t) => (
          <TabsTrigger key={t} value={t} data-testid={`admin-tab-${t}`} className="rounded-none px-0 py-3 uppercase tracking-[0.18em] text-xs data-[state=active]:shadow-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-[#1E3B2E]">{t === "rooms" ? "Rooms & Prices" : t === "offline" ? "Offline Admin" : t}</TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="bookings" className="pt-6"><BookingsTab /></TabsContent>
      <TabsContent value="rooms" className="pt-6"><RoomsTab /></TabsContent>
      <TabsContent value="settings" className="pt-6"><SettingsTab /></TabsContent>
      <TabsContent value="offline" forceMount className="pt-6 data-[state=inactive]:hidden"><OfflineTab /></TabsContent>
      <TabsContent value="users" className="pt-6"><UsersTab /></TabsContent>
    </Tabs>
  );
};

export default function Admin() {
  useSeo("Admin");
  return (
    <div className="bg-[#F4EFE6] min-h-screen py-10">
      <div className="container-x">
        <div className="flex items-center justify-between mb-8">
          <div><p className="eyebrow text-[#C28B5E]">Ananta Hotels</p><h1 className="text-4xl text-[#1E3B2E] tracking-tight">Admin</h1></div>
          <Show when="signed-in"><UserButton /></Show>
        </div>
        <Show when="signed-in"><Dashboard /></Show>
        <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
      </div>
    </div>
  );
}
